module.exports = __webpack_public_path__ + "img/copy-b.4f7749ef.svg";